module.exports = __webpack_public_path__ + "5d7d1ae4284dcd7b87a77df11cc53a97.pdf";